import Destination from "./Destination";
export default class Post {
  constructor({
    type,
    title,
    displayTitle,
    content,
    id,
    isPublished,
    nameId,
    url,
    season,
    pictures,
    destinations,
    themes,
    creator,
    originWebsite
  } = {}) {
    this.type = type || "";
    this.title = title || "";
    this.displayTitle = displayTitle || "";
    this.content = content || "";
    this.id = id || NaN;
    this.isPublished = isPublished || "";
    this.nameId = nameId || "";
    this.url = url || "";
    this.season = season || "";
    this.pictures = pictures || [];
    this.themes = themes || [];
    this.activities =
      this.themes.filter(x => x.category === "activities") || [];
    this.ambiances = this.themes.filter(x => x.category === "ambiances") || [];
    this.travellers =
      this.themes.filter(x => x.category === "travellers") || [];
    this.transports =
      this.themes.filter(x => x.category === "transports") || [];

    this.destinations = [];
    if (Array.isArray(destinations) && destinations.length > 0) {
      destinations.forEach(destination => {
        this.destinations.push(new Destination(destination));
      });
    } else {
      this.destinations.push(new Destination());
    }
    this.creator = creator || {};
    this.originWebsite = originWebsite;
  }
  getThemes() {
    return []
      .concat(this.activities, this.ambiances, this.transports, this.travellers)
      .map(x => x.nameEn);
  }
  getDataForCreateOrEditPost() {
    let destinations = [];
    for (let index = 0; index < this.destinations.length; index++) {
      destinations.push(this.destinations[index].getDataForCreateOrEditPost());
    }
    return destinations;
  }
  addDestination() {
    this.destinations.push(new Destination({ id: new Date().getTime() }));
  }
  deleteDestination(index) {
    this.destinations.splice(index, 1);
  }
}
